export const TRANSLATION_KEY =
  'descriptions.admin-portal.events.details.event-question';
export const QUESTION_MAX_LENGTH = 300;
